<gh-dropdown *ngIf="menuItems?.length > 0" [menuItems]="menuItems" [disabled]="disabled" dropdownMenuClass="comment-options" iconName="ellipsis"></gh-dropdown>
